// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2hiDC","label":"Labeled_label__35NUg","divider":"Labeled_divider__3dMUl"};